import * as React from "react";
import type { SVGProps } from "react";
const SvgUnlink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    viewBox="0 0 34 34" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m22.445 17.778 2.333-2.333a4.4 4.4 0 0 0 0-6.223v0a4.4 4.4 0 0 0-6.223 0l-2.333 2.333M13.89 20.11l6.22-6.22M11.555 16.222l-2.333 2.333a4.4 4.4 0 0 0 0 6.223v0a4.4 4.4 0 0 0 6.223 0l2.333-2.333"
    />
  </svg>
);
export default SvgUnlink;
